<template>
    <main
        class="d-flex flex-column"
        :class="`themed-${themeClass}`"
    >
        <router-view></router-view>
    </main>
</template>

<script>
import { hasClass } from '@H/class-list';

export default {
    name: 'Container',
    data() {
        return {
            themeClass: null
        }
    },
    beforeMount() {
        this.themeClass = hasClass(document.body, 'Theme_light') ? 'light' : 'standard';
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Widgets/Container.vue